import { Navigate } from "react-router";
import routesConstants from "./routeConstant";
import {
  AnalyticsPage,
  CategoryPage,
  CustomersPage,
  HomePage,
  LoginPage,
  OrderPage,
  PrivacyPolicyPage,
  ProductPage,
  ReferralPage,
  RetailerPage,
  ReturnPolicyPage,
  TermsConditionPage,
} from "./routeImport";

const routesConfig = {
  common: [
    {
      path: routesConstants.TERMSANDCONDITION,
      Component: TermsConditionPage,
    },
    {
      path: routesConstants.PRIVACY,
      Component: PrivacyPolicyPage,
    },
    {
      path: routesConstants.RETURN_POLICY,
      Component: ReturnPolicyPage,
    },
  ],
  private: [
    {
      path: "/",
      Component: () => <Navigate to={routesConstants.CUSTOMERS} />,
    },
    {
      path: routesConstants.CUSTOMERS,
      Component: CustomersPage,
    },
    {
      path: routesConstants.RETAILERS,
      Component: RetailerPage,
    },
    {
      path: routesConstants.PRODUCTS,
      Component: ProductPage,
    },
    {
      path: routesConstants.CATEGORY,
      Component: CategoryPage,
    },
    {
      path: routesConstants.ORDERS,
      Component: OrderPage,
    },
    {
      path: routesConstants.REFERRAL,
      Component: ReferralPage,
    },
    {
      path: routesConstants.ANALYTICS,
      Component: AnalyticsPage,
    },
    {
      path: "*",
      Component: () => <Navigate to={routesConstants.CUSTOMERS} />,
    },
  ],
  public: [
    {
      path: "/",
      Component: <Navigate to={routesConstants.LOGIN} />,
    },
    {
      path: routesConstants.LOGIN,
      Component: LoginPage,
    },
    {
      path: "*",
      Component: () => <Navigate to={routesConstants.LOGIN} />,
    },
    {
      path: routesConstants.HOME,
      Component: HomePage,
    },
  ],
};

export default routesConfig;
